import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../components/logos/property-button-logo.png'


const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "social-media-container" }
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = { class: "logo-container" }
const _hoisted_5 = { class: "logo-container" }

import FacebookLogo from '@/components/logos/facebook-logo.vue';
import FooterSwirl from './footer-swirl.vue';
import LinkedinLogo from '@/components/logos/linkedin-logo.vue';
import TwitterLogo from '@/components/logos/twitter-logo.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props) {

let screen = window.innerWidth;

const screenWidth = computed(()=>{
    if(screen > 480){
        return '375px';
    } else{
        return screen;
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"info-container\" data-v-41fb2efe><span class=\"header\" data-v-41fb2efe>Information</span><a href=\"https://propertybutton.ie/about.htm\" target=\"_blank\" data-v-41fb2efe>About Property Button</a><a href=\"https://propertybutton.ie/news.aspx\" target=\"_blank\" data-v-41fb2efe>Blogs</a><a href=\"https://propertybutton.ie/faq.htm\" target=\"_blank\" data-v-41fb2efe>Get in Touch</a><a href=\"https://propertybutton.ie/terms-and-conditions.htm\" target=\"_blank\" data-v-41fb2efe>Terms of Service</a><a href=\"https://propertybutton.ie/privacy.htm\" target=\"_blank\" data-v-41fb2efe>Privacy Policy</a></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "header" }, "Follow Us", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FacebookLogo)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LinkedinLogo)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TwitterLogo)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pb-logo-container" }, [
      _createElementVNode("a", {
        href: "https://propertybutton.ie/",
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          width: "150"
        })
      ])
    ], -1)),
    _createVNode(FooterSwirl, { width: screenWidth.value }, null, 8, ["width"])
  ]))
}
}

})